export enum GlobalTransactionStatus {
  Return = 'RETURN',
  Error = 'ERROR',
  Cancelled = 'CANCELLED',
  Pending = 'PENDING',
  Paid = 'PAID',
  Complete = 'COMPLETE',
}

export const PRETTY_TRANSACTION_STATUS = {
  [GlobalTransactionStatus.Return]: 'Return',
  [GlobalTransactionStatus.Error]: 'Error',
  [GlobalTransactionStatus.Cancelled]: 'Cancelled',
  [GlobalTransactionStatus.Complete]: 'Complete',
  [GlobalTransactionStatus.Paid]: 'Paid',
  [GlobalTransactionStatus.Pending]: 'Pending'
}
